import styled from '@emotion/styled';

import { BRAND_COLORS, COLORS } from 'styles/theme';

const ResultMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: 1.5rem 0;

  & > .emoji {
    font-size: 4.6rem;
    margin-bottom: 1.2rem;
  }

  & > .title {
    font-size: 2rem;
    color: ${BRAND_COLORS.primary};
    margin-bottom: 1rem;
  }

  & > .description {
    font-size: 1.2rem;
    letter-spacing: 0.063rem;
    color: ${COLORS.silverChalice};
  }
`;

export default ResultMessage;
